"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const GoogleAnalytics_1 = __importDefault(require("./GoogleAnalytics"));
exports.default = GoogleAnalytics_1.default;
